(function () {
  'use strict';

  var pending = new WeakMap();

  function getProduct(target) {
    return target && target.closest ? target.closest('xo-product') : null;
  }

  function getVariants(product) {
    if (product.__xoVariantCache) return product.__xoVariantCache;

    var skuContainer = product.querySelector('[data-product-sku-container]');
    var json = skuContainer && skuContainer.querySelector('[data-product-variants-json]');
    if (!json) return [];

    try {
      product.__xoVariantCache = JSON.parse(json.textContent || '[]');
    } catch (error) {
      product.__xoVariantCache = [];
    }
    return product.__xoVariantCache;
  }

  function selectedOptions(product) {
    return Array.prototype.map.call(
      product.querySelectorAll('.xo-product-info-variant'),
      function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        var select = group.querySelector('select');
        return checked ? checked.value : (select ? select.value : '');
      }
    );
  }

  function selectedVariant(product) {
    var variants = getVariants(product);
    if (!variants.length) return null;

    var formId = product.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = formId && String(formId.value || '');
    var byId = id && variants.find(function (variant) {
      return String(variant.id) === id;
    });
    if (byId) return byId;

    var options = selectedOptions(product);
    return variants.find(function (variant) {
      return Array.isArray(variant.options) &&
        variant.options.length === options.length &&
        variant.options.every(function (value, index) {
          return String(value) === String(options[index]);
        });
    }) || null;
  }

  function syncLabels(product) {
    product.querySelectorAll('.xo-product-info-variant').forEach(function (group) {
      var output = group.querySelector('.xo-product-info-variant__name');
      if (!output) return;

      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('select');
      var value = checked ? checked.value : (select ? select.value : '');

      if (value && output.textContent.trim() !== value) {
        output.textContent = value;
      }
    });
  }

  function syncSku(product) {
    var output = product.querySelector('[data-product-sku-container] [data-product-sku]');
    if (!output) return;

    var variant = selectedVariant(product);
    if (!variant) return;

    var sku = variant.sku || '';
    if (output.textContent !== sku) output.textContent = sku;
  }

  function sync(product) {
    if (!product || !product.isConnected) return;
    syncLabels(product);
    syncSku(product);
  }

  function schedule(product) {
    if (!product) return;

    var oldTimer = pending.get(product);
    if (oldTimer) window.clearTimeout(oldTimer);

    // One update after Amolia has committed its hidden variant ID/automatic option correction.
    pending.set(product, window.setTimeout(function () {
      pending.delete(product);
      sync(product);
    }, 80));
  }

  function optionEvent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches('.xo-product-info-variant input, .xo-product-info-variant select, form[action*="/cart/add"] input[name="id"]')) {
      schedule(getProduct(target));
    }
  }

  document.addEventListener('change', optionEvent, true);
  document.addEventListener('input', optionEvent, true);

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element
      ? event.target.closest('.xo-product-info-variant label, .xo-product-info-variant input')
      : null;
    if (target) schedule(getProduct(target));
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('xo-product').forEach(sync);
  });

  // Shopify theme editor reloads sections explicitly; no page-wide MutationObserver needed.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target instanceof Element ? event.target : document;
    root.querySelectorAll('xo-product').forEach(sync);
  });
})();
